// Mock data for the care circles index — the rows of the CAM admin table, one
// per care circle. Stands in for the list API. Mirrors the care-search world
// (a carer set up KareHero for the person they look after) rather than
// inventing new people.

export type CircleCaseManager = {
  name: string;
  initials: string;
};

export type CareCircleRow = {
  // The care circle's short reference, shown in the table and used as the row
  // key.
  id: string;
  // The KareHero member who owns the circle — usually the person arranging care.
  carer: string;
  // The person the circle is caring for.
  careRecipient: string;
  email: string;
  // The assigned care expert (CAM). Unassigned circles have none yet.
  caseManager?: CircleCaseManager;
  // Initials of the people watching the circle (family, professionals). An
  // empty list means nobody has been added as a watcher yet.
  watchers: string[];
};

// The signed-in care expert. A stand-in until the prototype wires real
// identity; the caseload filter and the cover tab both key off it, so it lives
// here rather than in either of them.
export const SIGNED_IN_CAM = 'Brett-Yasmin';

// Every care expert a circle can be assigned to. A list of its own rather than
// one derived from who already owns something: a circle has to be assignable to
// somebody with an empty caseload, and that is exactly the person a derived
// list leaves out.
export const CASE_MANAGERS: CircleCaseManager[] = [
  { name: 'Brett-Yasmin', initials: 'BY' },
  { name: 'Priya Nair', initials: 'PN' },
  { name: 'James Okonkwo', initials: 'JO' },
  { name: 'Amara Osei', initials: 'AO' },
  { name: 'Abbie Lawson', initials: 'AL' },
];

export const CASE_MANAGER_NAMES = (): string[] =>
  CASE_MANAGERS.map((m) => m.name);

export const CARE_CIRCLES: CareCircleRow[] = [
  {
    id: 'CC-4821',
    carer: 'Margarette Qualley',
    careRecipient: 'Eleanor Qualley',
    email: 'm.qualley@gmail.com',
    caseManager: { name: 'Brett-Yasmin', initials: 'BY' },
    watchers: ['RM', 'JP'],
  },
  {
    id: 'CC-4805',
    carer: 'David Osei',
    careRecipient: 'Grace Osei',
    email: 'david.osei@outlook.com',
    caseManager: { name: 'Priya Nair', initials: 'PN' },
    watchers: ['SO'],
  },
  {
    id: 'CC-4790',
    carer: 'Hannah Whitfield',
    careRecipient: 'Robert Whitfield',
    email: 'h.whitfield@icloud.com',
    caseManager: { name: 'Brett-Yasmin', initials: 'BY' },
    watchers: ['TW', 'CW', 'LB'],
  },
  {
    id: 'CC-4776',
    carer: 'Aisha Rahman',
    careRecipient: 'Fatima Rahman',
    email: 'aisha.rahman@gmail.com',
    watchers: [],
  },
  {
    id: 'CC-4761',
    carer: 'Callum Fraser',
    careRecipient: 'Morag Fraser',
    email: 'callum.fraser@btinternet.com',
    caseManager: { name: 'James Okonkwo', initials: 'JO' },
    watchers: ['EF'],
  },
  {
    id: 'CC-4748',
    carer: 'Sofia Marchetti',
    careRecipient: 'Giovanni Marchetti',
    email: 's.marchetti@gmail.com',
    caseManager: { name: 'Priya Nair', initials: 'PN' },
    watchers: ['LM', 'AM'],
  },
  {
    id: 'CC-4732',
    carer: 'Thomas Reid',
    careRecipient: 'Margaret Reid',
    email: 'tom.reid@yahoo.co.uk',
    watchers: [],
  },
  {
    id: 'CC-4719',
    carer: 'Nia Llewellyn',
    careRecipient: 'Owen Llewellyn',
    email: 'nia.llewellyn@gmail.com',
    caseManager: { name: 'James Okonkwo', initials: 'JO' },
    watchers: ['GL', 'DL'],
  },
];
